<template>
    <v-layout align-top>
        <v-flex>
            <v-card flat>
                <v-card-title class="primary white--text headline">
                    {{ 'Fault Detection'|translate }}
                    <v-spacer></v-spacer>
                    <v-menu v-if="equipment&&equipment!==''">
                        <template v-slot:activator="{ on }">
                            <v-btn
                                dark
                                icon
                                v-on="on"
                            >
                                <v-icon>fa-ellipsis-v</v-icon>
                            </v-btn>
                        </template>

                        <v-list>
                            <v-list-tile
                                @click="$router.push({path: '/modelsummary',query: {rangeStart:range.start,rangeEnd:range.end,equipment:equipment}})">
                                <v-list-tile-title>{{ 'View anomalies for'|translate }} {{ equipment }}
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile
                                @click="$router.push({path: '/notification-breakdown',query: {rangeStart:range.start,rangeEnd:range.end,equipment_name:equipment}})">
                                <v-list-tile-title>{{ 'View notifications for'|translate }} {{ equipment }}
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile
                                @click="$router.push({path: '/equipment-summary',query: {rangeStart:range.start,rangeEnd:range.end,equipment:equipment}})">
                                <v-list-tile-title>{{ 'View equipment summary for'|translate }} {{ equipment }}
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>

                </v-card-title>
                <v-layout row wrap>

                    <v-flex xs12>
                        <v-card>
                            <v-card-text>
                                <date-range-selector v-model="range"></date-range-selector>
                                <equipment-selector v-on:ect="equipemntTypeChange($event)" v-model="equipment"
                                                    :typeFilter="typeFilter" clearable></equipment-selector>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12>
                        <v-card>
                            <v-card-title class="accent white--text subheading">
                                <span v-show="hasIssues">{{ 'Fault'|translate }}</span>
                                <span
                                    v-show="!hasIssues">{{ 'No fault detected from'|translate }} {{ range.start }} {{ 'to'|translate }} {{ range.end }}</span>
                            </v-card-title>
                            <v-card-text v-show="!hasIssues">
                                <ul>
                                    <li v-for="rule in rules" v-if="rule.equipment_group===equipmentType">
                                        {{ rule.title }}
                                    </li>
                                </ul>
                            </v-card-text>
                            <v-card-text v-if="hasIssues">
                                <fault-summary :range="range" :facility-name="facilityName"
                                               :equipment-name="equipment"></fault-summary>
                            </v-card-text>
                            <v-card-text>
                                <loading-progress-bar :loading="loading"></loading-progress-bar>
                                <vue-plotly v-if="!loading&&hasIssues" disable-responsive :data="mydata"
                                            :layout="layout" :options="options" @click="clickFault"></vue-plotly>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
    </v-layout>

</template>

<script>
import VuePlotly from '@/components/VuePlotly'
import DateRangeSelector from '../components/DateRangeSelector'
import EquipmentSelector from '../components/EquipmentSelector'
import {getIssues, getRule} from '@/helper'
import LoadingProgressBar from '../components/LoadingProgressBar'
import _ from 'lodash'
import FaultSummary from '../components/faults/FaultSummary'
import moment from 'moment'
import {mapGetters} from 'vuex'

export default {
    name: 'Fault',
    components: {FaultSummary, LoadingProgressBar, EquipmentSelector, DateRangeSelector, VuePlotly},
    data() {
        return {
            rule: null,
            equipmentType: null,
            loading: true,
            range: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
            equipment: 'Chiller 1',
            rules: [],
            timeout: null,
            df: null,
            hasIssues: false,
            layout: {
                hovermode: 'closest',
                yaxis: {
                    title: this.$options.filters.translate('Issue'),
                    automargin: true,
                },
                xaxis: {
                    title: this.$options.filters.translate('Time'),
                }
            },
            options: {},
            mydata: [],
            mapping: {}
        }
    },
    computed: {
        ...mapGetters([
            'faultEquipType',
        ]),
        facilityName() {
            return this.$store.state.pointsListStore.pointsList.facility_name
        },
        typeFilter() {
            if (this.faultEquipType) {
                return this.faultEquipType
            } else {
                return (this.facilityName == 'ES3' || this.facilityName == 'ES') ? "" : "chiller,pump,header"
            }
        }
    },
    watch: {
        range() {
            this.updateQueryString()
            this.refresh()
        },
        equipment() {
            this.updateQueryString()
            this.refresh()
        }
    },
    methods: {
        updateQueryString() {
            if (this.$router.currentRoute.name === "fault") {
                this.$router.replace({
                    path: '/fault',
                    query: {
                        rangeStart: this.range.start,
                        rangeEnd: this.range.end,
                        equipment: this.equipment
                    }
                }).catch(err => {
                })
            }
        },
        equipemntTypeChange(event) {
            this.equipmentType = event;
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        refresh() {
            this.debounce(this.doRefresh, 200);
        },
        async doRefresh() {
            this.loading = true
            this.layout.xaxis.range = [this.range.start, this.range.end];
            let df = await getIssues(
                this.equipment,
                this.$store.state.pointsListStore.pointsList.facility_name,
                {'start': this.range.start, 'end': this.range.end}
            )


            let timeAxis = [];
            let ts = moment(this.range.start).format('YYYY-MM-DD HH:mm:ss')
            let end = moment(this.range.end).format('YYYY-MM-DD HH:mm:ss')
            while (ts <= end) {
                timeAxis.push(ts)
                ts = moment(ts).add(this.$store.getters.minutesBetweenSamples, 'minutes').format('YYYY-MM-DD HH:mm:ss')
            }
            let refinedDf = {
                x: timeAxis,
                y: [...new Set(df['issue'])],
                z: []
            }

            for (let issue of refinedDf.y) {
                let newZ = new Array(timeAxis.length).fill(0);
                for (let index in df['issue']) {
                    if (df['issue'][index] === issue) {
                        newZ[timeAxis.indexOf(df['timestamp'][index])] = 1;
                    }
                }
                refinedDf.z.push(newZ)
            }


            this.hasIssues = refinedDf.y.length > 0
            this.mydata = [{
                x: refinedDf.x,
                y: refinedDf.y,
                z: refinedDf.z,
                type: 'heatmap',
                showscale: false,
                colorscale: [
                    [0, process.env.VUE_APP_THEME == 'dark' ? '#424242' : '#FFFFFF'],
                    [1, '#3D9971']
                ]

            }]
            this.layout.height = Math.max(400, 26 * refinedDf.y.length)
            this.loading = false
            let rules = await getRule({'facility_name': this.$store.state.pointsListStore.pointsList.facility_name})
            this.rules = rules.result
            let output = {}

            for (let i in rules.result) {
                output[rules.result[i]['title']] = rules.result[i]['relevant_variables']
            }
            this.mapping = output
        },
        clickFault(data) {
            if (!this.equipment) {
                return
            }
            let mapping = this.mapping
            if (!data.points[0].z) {
                //does not jump when no actual issue
                return
            }
            if (_.get(mapping, data.points[0].y, '') === '') {
                // does not jump when variable is not defined here
                return
            }
            let startDate = new Date(data.points[0].x.substring(0, 10))
            startDate.setDate(startDate.getDate() - 1)
            let endDate = new Date(data.points[0].x.substring(0, 10))
            endDate.setDate(endDate.getDate() + 1)
            let output = {
                path: '/fault-analysis',
                query: {
                    relevantVariables: _.get(mapping, data.points[0].y, ''),
                    faultName: data.points[0].y,
                    faultDesc: data.points[0].y,
                    rangeStart: startDate.toISOString().slice(0, 10),
                    rangeEnd: endDate.toISOString().slice(0, 10),
                    equipmentName: this.equipment
                }
            }
            this.$router.push(output)
        }
    },
    mounted() {
        this.refresh()
    },
    beforeMount() {
        let maxDate = this.$store.state.pointsListStore.pointsList.data_max_date;
        this.equipment = _.get(this.$route.query, 'equipment', null)
        let rangeStart = _.get(this.$route.query, 'rangeStart', null)
        let rangeEnd = _.get(this.$route.query, 'rangeEnd', null)
        if (!!rangeStart) {
            this.range = {start: rangeStart, end: rangeEnd}
        } else if (maxDate) {
            this.range = {
                start: moment(maxDate).subtract(30, "days").format('YYYY-MM-DD HH:mm:ss'),
                end: moment(maxDate).format('YYYY-MM-DD HH:mm:ss')
            }
        }
    },
}
</script>

<style scoped>

</style>
